<template>
  <v-card class="mx-auto mb-5">
    <v-expansion-panels accordion class="elevation-0" v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="text-body-2 font-weight-bold">{{
          currentTitle(1)
        }}</v-expansion-panel-header>
        <v-expansion-panel-content
          v-if="Object.entries(dsFactura).length !== 0"
        >
          <encabezado
            :data="InfoFact(encabezado)"
            v-if="tabMovil === documentospendiente"
          />
          <encabezadoped
            :data="InfoFact(encabezado)"
            v-if="tabMovil === pedidotransito"
          />
          <encabezadoped
            :data="InfoFact(encabezado)"
            v-if="tabMovil === pedidoporaut"
          />
          <encabezadopresup
            :data="InfoFact(encabezado)"
            v-if="tabMovil === pedidopresupuesto"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="text-body-2 font-weight-bold">{{
          currentTitle(0)
        }}</v-expansion-panel-header>
        <v-expansion-panel-content
          v-if="Object.entries(dsFactura).length !== 0"
        >
          <pieFactura
            :data="InfoFact(total)"
            v-if="tabMovil === documentospendiente"
          />
          <piePedido
            :data="InfoFact(total)"
            v-if="tabMovil === pedidotransito"
          />
          <piePedido
            :data="InfoFact(total)"
            v-if="tabMovil === pedidopresupuesto"
          />
          <piePedido :data="InfoFact(total)" v-if="tabMovil === pedidoporaut" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="text-body-2 font-weight-bold">
          Ver Items
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-virtual-scroll
      :bench="benched"
      :items="itemFac"
      height="320"
      item-height="130"
    
    >
      <template v-slot:default="{ item }">
        <v-list-item three-line :key="item.Codigo" dense>
         
          <v-list-item-avatar tile size="60">
            <ImgInsideRow  :codart="item.Codigo" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Codigo:</span>
                    <span class="font-weight-bold">
                      {{ `${item.Codigo}` }}
                    </span>
                  </v-list-item-subtitle>
            <v-list-item-subtitle
              class="text-no-wrap text-left text-caption font-weight-bold"
            >
              {{ `${item.Nombre}` }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="d-flex justify-space-between">
              <span>Cant:</span>
              <span class="font-weight-bold">{{ `  ${item.Cantidad}` }}</span>
              <span>Precio:</span>
              <span class="font-weight-bold">
                {{
                  `${format(item.PrecioUni[tipoMoneda], 1)} ${simboloMoneda[tipoMoneda]}`
                }}</span
              >
            </v-list-item-subtitle>
            <v-list-item-subtitle class="d-flex justify-space-between">
              
            </v-list-item-subtitle>
            <v-list-item-subtitle
              class="d-flex justify-space-between"
              v-if="item.Descuento !== 0"
            >
              <span>Desc:</span>
              <span class="font-weight-bold"> {{ `${item.Descuento} %` }}</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle
            class="d-flex justify-space-between"
            >
            <span>Neto:</span>
            <span class="font-weight-bold"> {{ ` ${format(item.PrecioNeto[tipoMoneda], 1)} ${simboloMoneda[tipoMoneda]}` }}</span>
             
              
            </v-list-item-subtitle>
            <v-list-item-subtitle
            class="d-flex justify-space-between"
            >
            <span>Total:</span>
              <span class="font-weight-bold">
                {{ `${format(item.PrecioTot[tipoMoneda], 1)} ${simboloMoneda[tipoMoneda]}` }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
    </v-virtual-scroll>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    
   
  </v-card>
</template>

<script>
import { format, formatFecha } from "@/static/funciones";
import imgPredet from "@/components/ImgPred";
import ImgInsideRow from "@/components/ImgInsideRow";

import encabezado from "./EncabezadoFactura";
import encabezadoped from "./EncabezadoPedido";
import encabezadopresup from "./EncabezadoPresupuesto";
import pieFactura from "./PieFactura";
import piePedido from "./PiePedido";
import { mapState } from "vuex";
export default {
  components: {
    imgPredet,
    encabezado,
    encabezadoped,
    encabezadopresup,
    pieFactura,
    piePedido,
    ImgInsideRow,
  },
 
  data() {
    return {
      benched: 0,
      documentospendiente: 3,
      pedidotransito: 4,
      pedidoporaut: 6,
      pedidopresupuesto: 7,
      encabezado: 0,
      total: 1,
      panel: 1,
    };
  },
  methods: {
    format,
    formatFecha,
  },
  computed: {
    ...mapState(["tabMovil", "tipoMoneda", "dsFactura",  "simboloMoneda",]),
    currentTitle: function () {
      return function (key) {
        const titulo = {
          3: `Ver ${key !== 0 ? "Datos" : `Total`} Factura`,
          4: `Ver ${key !== 0 ? "Datos" : `Total`} Pedido`,
          6: `Ver ${key !== 0 ? "Datos" : `Total`} Pedido`,
          7: `Ver ${key !== 0 ? "Datos" : `Total`} Presupuesto`,
        };
        return titulo[this.tabMovil];
      };
    },

    Info: function () {
      let datos = null;
      if (Object.entries(this.dsFactura).length !== 0) {
        let { DatosFactura } = this.dsFactura || {}; //DatosPedido
        let { DatosPedido } = this.dsFactura || {}; //DatosPedido
        if (DatosFactura !== undefined) {
          datos = DatosFactura[0];
        }
        if (DatosPedido !== undefined) {
          datos = DatosPedido[0];
        }
      }
      return datos;
    },
    InfoFact: function () {
      return function (nodo) {
        let datos = {};
        if (Object.entries(this.dsFactura).length !== 0) {
          let { DatosFactura } = this.dsFactura || {}; //DatosPedido
          let { DatosPedido } = this.dsFactura || {}; //DatosPedido
          let { TotalesPedido } = this.dsFactura || {}; //DatosPedido
          if (DatosFactura !== undefined) {
            datos = {
              principal: {
                NumeroDoc: DatosFactura[0][`NumeroDoc`],
                Descrip: `Factura N° ${DatosFactura[0][`NumeroDoc`]}`,
                NombreCli: DatosFactura[0][`NombreCli`],
                FechaEntregaCli: this.formatFecha(
                  DatosFactura[0][`FechaEntregaCli`],
                  1
                ),
                CondicionPago: DatosFactura[0][`CondicionPago`],
                TipoDoc: DatosFactura[0][`TipoDoc`],
                FechaEmision: this.formatFecha(
                  DatosFactura[0][`FechaEmision`],
                  1
                ),
                FechaVence: this.formatFecha(DatosFactura[0][`FechaVence`], 1),
                NumeroPedido: DatosFactura[0][`NumeroPedido`],
              },
              total: {
                MontoBruto: this.format(
                  DatosFactura[0][`MontoBruto`][this.tipoMoneda],
                  1
                ),
                MontoDescuento: this.format(
                  DatosFactura[0][`MontoDescuento`][this.tipoMoneda],
                  1
                ),
                MontoNeto: this.format(
                  DatosFactura[0][`MontoNeto`][this.tipoMoneda],
                  1
                ),
                MontoExento: this.format(
                  DatosFactura[0][`MontoExento`][this.tipoMoneda],
                  1
                ),
                MontoIva: this.format(
                  DatosFactura[0][`MontoIva`][this.tipoMoneda],
                  1
                ),
                MontoTotal: this.format(
                  DatosFactura[0][`MontoTotal`][this.tipoMoneda],
                  1
                ),
              },
            };
          }
          if (DatosPedido !== undefined) {
            datos = {
              principal: {
                NumeroPedido: DatosPedido[0][`NumeroPedido`],
                Descrip: `${
                  this.tabMovil === this.pedidopresupuesto
                    ? `Presupuesto N° `
                    : `Pedido N° `
                } ${DatosPedido[0][`NumeroPedido`]}`,
                Referencia: DatosPedido[0][`Referencia`],
                CodigoCli: DatosPedido[0][`CodigoCli`],
                RIF: DatosPedido[0][`RIF`],
                NombreCli: DatosPedido[0][`NombreCli`],
                CondicionPago: DatosPedido[0][`CondicionPago`],
                FechaVencimiento:
                  this.tabMovil === this.pedidopresupuesto
                    ? this.formatFecha(DatosPedido[0][`FechaVencimiento`], 1)
                    : "",
                FechaPedido: this.formatFecha(DatosPedido[0][`FechaPedido`], 1),
                StatusPed: DatosPedido[0][`StatusPed`],
                TipoPedido: DatosPedido[0][`TipoPedido`],
                Transporte: DatosPedido[0][`Transporte`],
                Descuento: DatosPedido[0][`Descuento`],
              },
              total: {
                MontoBruto: this.format(
                  TotalesPedido[0][`MontoBruto`][this.tipoMoneda],
                  1
                ),
                MontoDescuento: this.format(
                  TotalesPedido[0][`MontoDescuento`][this.tipoMoneda],
                  1
                ),
                MontoNeto: this.format(
                  TotalesPedido[0][`MontoNeto`][this.tipoMoneda],
                  1
                ),
                MontoIva: this.format(
                  TotalesPedido[0][`MontoIva`][this.tipoMoneda],
                  1
                ),
                MontoTotal: this.format(
                  TotalesPedido[0][`MontoTotal`][this.tipoMoneda],
                  1
                ),
              },
            };
          }
        }
        const nodoDetalle = {
          0: `principal`,
          1: `total`,
        };
        const index = nodoDetalle[nodo];
        const res = datos[index];
        return res;
      };
    },
    itemFac() {
      let datos = [];
      if (Object.entries(this.dsFactura).length !== 0) {
        let { ItemsFactura } = this.dsFactura || {};
        let { ItemsPedido } = this.dsFactura || {};
        if (ItemsFactura !== undefined) {
          datos = ItemsFactura;
        }
        if (ItemsPedido !== undefined) {
          datos = ItemsPedido;
        }
        console.log(ItemsPedido);
      }
      return datos;
    },
  },
};
</script>
